import React from "react";

const CenterWrapper = ({ children, className }) => {
  return (
    <div className={"container mx-auto px-4 " + className}>{children}</div>
  );
};

export default CenterWrapper;
